export default __webpack_public_path__ + "static/media/p.ccc0583b.png";